import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { FormGroup, UntypedFormGroup } from '@angular/forms';
import { Observable, of, throwError } from 'rxjs';
import { setFormErrors } from '@loreal-www-frontend/shared';

@Injectable({
  providedIn: 'root',
})
export class FormErrorHandlerService {
  constructor(private readonly _toastrService: ToastrService) {}

  public catchFormError(error: any, formGroup: UntypedFormGroup | FormGroup): Observable<unknown> {
    this._displayErrorMessageIfExists(error);
    if (error?.error?.code === 400) {
      setFormErrors(error?.error?.errors?.children, formGroup);
      formGroup.updateValueAndValidity();
      return of(null);
    }
    return throwError(() => error);
  }

  private _displayErrorMessageIfExists(error: any): void {
    if (
      error?.error?.errors?.errors &&
      Array.isArray(error?.error?.errors?.errors) &&
      error?.error?.errors?.errors.length
    ) {
      error?.error?.errors?.errors.forEach((err: string) => {
        this._toastrService.error(err);
      });
    }
  }
}
